import { useFormContext } from 'react-hook-form';
import { BoolRadioField, TextField } from '@views/register/history/history-fields';
import type { TLocalize } from '@hooks/use-localize';
import type { IHistorySocialFormValues } from '@/types/history/history-social';

interface IProps {
    t: TLocalize;
}

const LegalTravelSection = ({ t }: IProps) => {
    const { watch } = useFormContext<IHistorySocialFormValues>();

    const yes = t('Word_Yes', 'Yes');
    const no = t('Word_No', 'No');

    return (
        <>
            <BoolRadioField
                name="hasHadLegalIssues"
                label={t('DashLabel_HaveYouEverBeenInvolvedInLegalIssuesInvolvingLawEn', 'Have you ever been involved in legal issues involving law enforcement (including DWI)')}
                yesLabel={yes}
                noLabel={no}
            />

            {watch('hasHadLegalIssues') === '1' && (
                <div className="sub-question">
                    <BoolRadioField
                        name="hasBeenSentencedToPrison"
                        label={t('DashLabel_HaveYouEverBeenSentencedToPrisonTime', 'Have you ever been sentenced to prison time')}
                        yesLabel={yes}
                        noLabel={no}
                    />

                    {watch('hasBeenSentencedToPrison') === '1' && (
                        <div className="sub-question">
                            <TextField
                                name="prisonWhenAndWhere"
                                label={t('DashLabel_WhenAndWhereWereYouInPrison', 'When and where were you in prison')}
                                maxLength={128}
                            />
                        </div>
                    )}
                </div>
            )}

            <BoolRadioField
                name="hasTraveledLastYear"
                label={t('DashLabel_HaveYouTraveledMoreThan100MilesFromYourHomeInTheLa', 'Have you traveled more than 100 miles from your home in the last year')}
                yesLabel={yes}
                noLabel={no}
            />

            {watch('hasTraveledLastYear') === '1' && (
                <div className="sub-question">
                    <TextField
                        name="travelLocations"
                        label={t('DashLabel_WhereDidYouTravel', 'Where did you travel')}
                        maxLength={255}
                    />
                </div>
            )}
        </>
    );
};

export default LegalTravelSection;
